import { type LogoRepository, getLogo } from '~/domains/core';

const logoLocalRepository: LogoRepository = {
  async getLogo() {
    return getLogo();
  },
};

export default logoLocalRepository;
